import React, { useState, useEffect } from "react";
import "./FilterBar.css";

const FilterBar = ({ onFilterChange, transactionType, properties }) => {
  const initialFilters = {
    location: "",
    minPrice: "",
    maxPrice: "",
    minBedrooms: "",
    maxBedrooms: "",
  };

  const [filters, setFilters] = useState(initialFilters);
  const [showFilters, setShowFilters] = useState(false);
  
  // Price options based on transaction type (Sales or Lettings)
  const priceOptions = {
    sales: [
      50000, 100000, 150000, 200000, 250000, 300000, 350000, 400000, 450000,
      500000, 550000, 600000, 650000, 700000, 800000, 900000, 1000000,
    ],
    lettings: [
      500, 750, 1000, 1250, 1500, 2000, 2500, 3000, 3500, 4000, 5000, 7500,
      10000, 50000,
    ],
  };

  // Bedroom options
  const bedroomOptions = [0, 1, 2, 3, 4, 5];

  // Determine current price options based on transactionType
  const currentPriceOptions =
    transactionType === "1" ? priceOptions.sales : priceOptions.lettings;

  useEffect(() => {
    // Reset min/max price when transaction type changes
    setFilters((prevFilters) => ({
      ...prevFilters,
      minPrice: "",
      maxPrice: "",
    }));
  }, [transactionType]);

  const filterProperties = (properties, filters) => {
    return properties.filter((property) => {
      const {
        location,
        minPrice,
        maxPrice,
        minBedrooms,
        maxBedrooms,
      } = filters;

      const propertyBedrooms = parseInt(property.bedrooms, 10);

      return (
        (!location || property.location.toLowerCase().includes(location.toLowerCase())) &&
        (!minPrice || property.price >= parseInt(minPrice, 10)) &&
        (!maxPrice || property.price <= parseInt(maxPrice, 10)) &&
        (minBedrooms === undefined || propertyBedrooms >= minBedrooms) &&
        (maxBedrooms === undefined || propertyBedrooms <= maxBedrooms)
      );
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  };

  const applyFilters = () => {
    const minBedrooms = filters.minBedrooms !== "" ? parseInt(filters.minBedrooms, 10) : undefined;
    const maxBedrooms = filters.maxBedrooms !== "" ? parseInt(filters.maxBedrooms, 10) : undefined;

    const updatedFilters = {
      ...filters,
      minBedrooms,
      maxBedrooms,
    };

    console.log("Applying filters:", updatedFilters);
    onFilterChange(updatedFilters);
  };

  const resetFilters = () => {
    setFilters(initialFilters);
    onFilterChange(initialFilters);
  };

  return (
    <div className="sideBar">
      <input
        type="text"
        name="location"
        placeholder="Search location e.g. N9 or Essex"
        value={filters.location}
        onChange={handleChange}
        className="sideLocation"
      />

      <button
        className="showFiltersButton"
        onClick={() => setShowFilters(!showFilters)}
      >
        {showFilters ? "Hide Filters" : "Show Filters"}
      </button>

      <div className={`filterOptions ${showFilters ? "visible" : ""}`}>
        <div className="priceFilters">
          <div className={`filterGroup ${filters.minPrice ? "hasValue" : ""}`}>
            {filters.minPrice && <label className="filterLabel">Min Price</label>}
            <select name="minPrice" value={filters.minPrice} onChange={handleChange}>
              <option value="">Min Price</option>
              {currentPriceOptions.map((price) => (
                <option key={price} value={price}>
                  {transactionType === "1" ? `£${price.toLocaleString()}` : `£${price.toLocaleString()} pcm`}
                </option>
              ))}
            </select>
          </div>

          <div className={`filterGroup ${filters.maxPrice ? "hasValue" : ""}`}>
            {filters.maxPrice && <label className="filterLabel">Max Price</label>}
            <select name="maxPrice" value={filters.maxPrice} onChange={handleChange}>
              <option value="">Max Price</option>
              {currentPriceOptions.map((price) => (
                <option key={price} value={price}>
                  {transactionType === "1" ? `£${price.toLocaleString()}` : `£${price.toLocaleString()} pcm`}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="bedroomFilters">
          <div className={`filterGroup ${filters.minBedrooms ? "hasValue" : ""}`}>
            {filters.minBedrooms && <label className="filterLabel">Min Bed</label>}
            <select name="minBedrooms" value={filters.minBedrooms} onChange={handleChange}>
              <option value="">Min Bed</option>
              {bedroomOptions.map((option) => (
                <option key={option} value={option}>{option}</option>
              ))}
            </select>
          </div>

          <div className={`filterGroup ${filters.maxBedrooms ? "hasValue" : ""}`}>
            {filters.maxBedrooms && <label className="filterLabel">Max Bed</label>}
            <select name="maxBedrooms" value={filters.maxBedrooms} onChange={handleChange}>
              <option value="">Max Bed</option>
              {bedroomOptions.map((option) => (
                <option key={option} value={option}>{option}</option>
              ))}
            </select>
          </div>
        </div>

        <div className="filterButtons">
          <button onClick={applyFilters} className="applyButton">Apply Filters</button>
          <button onClick={resetFilters} className="resetButton">Reset Filters</button>
        </div>
      </div>
    </div>
  );
};

export default FilterBar;
